import api from "@/services/api";

/**
 * @description Servicio para interactuar con el endpoint /provider-network.
 * Gestiona el CRUD de prestadores de la red.
 */
const providerNetworkService = {};

const endpoint = "/provider-network";

/**
 * @description Obtiene listado paginado de prestadores con filtros
 * @param {Object} params - Parámetros de búsqueda
 * @param {string} [params.searchInput] - Texto de búsqueda
 * @param {string} [params.specialty] - Filtrar por especialidad
 * @param {string} [params.type] - Filtrar por tipo (individual, institution)
 * @param {string} [params.status] - Filtrar por estado
 * @param {number} [params.offset] - Offset para paginación
 * @param {number} [params.limit] - Límite de resultados
 * @returns {Promise<{docs: Array, total: number}>} Resultado paginado
 */
providerNetworkService.query = function (params) {
  return api.get(endpoint, { params }).then((res) => res.data);
};

/**
 * @description Obtiene un prestador por su ID
 * @param {string} id - ID del prestador
 * @returns {Promise<Object>} Datos del prestador
 */
providerNetworkService.getById = function (id) {
  return api.get(`${endpoint}/${id}`).then((res) => res.data);
};

/**
 * @description Crea un nuevo prestador en la red
 * @param {Object} data - Datos del prestador
 * @param {string} data.cuit - CUIT
 * @param {string} data.businessName - Razón social
 * @param {string} data.type - Tipo (individual, institution)
 * @param {string[]} [data.specialties] - Especialidades
 * @param {string} [data.contract] - Contrato
 * @param {string} [data.status] - Estado
 * @returns {Promise<Object>} Prestador creado
 */
providerNetworkService.create = function (data) {
  return api.post(endpoint, data).then((res) => res.data);
};

/**
 * @description Actualiza un prestador existente
 * @param {string} id - ID del prestador
 * @param {Object} data - Campos a actualizar
 * @returns {Promise<Object>} Prestador actualizado
 */
providerNetworkService.update = function (id, data) {
  return api.put(`${endpoint}/${id}`, data).then((res) => res.data);
};

/**
 * @description Elimina un prestador de la red
 * @param {string} id - ID del prestador
 * @returns {Promise<void>}
 */
providerNetworkService.remove = function (id) {
  return api.delete(`${endpoint}/${id}`);
};

export default providerNetworkService;
